/**
 * Nexoriq attribution capture.
 * On first visit in a session, we snapshot the UTM params, gclid/fbclid,
 * referrer, and landing path from the URL — stored in sessionStorage so the
 * RFQ form can attach them at submit time even if the user navigates.
 */
const KEY = "nx_attribution";
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
];

function readSaved() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.warn("attribution: failed to read saved attribution", err);
    return null;
  }
}

function save(obj) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(obj));
  } catch (err) {
    console.warn("attribution: failed to persist attribution", err);
  }
}

/**
 * Called once on app mount. Merges URL UTMs into stored attribution if present.
 * Preserves the FIRST-touch referrer / landing_path.
 */
export function captureAttribution() {
  try {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const fromUrl = {};
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) fromUrl[k] = v;
    }
    const existing = readSaved() || {};
    const merged = {
      ...existing,
      ...fromUrl,
    };
    // First-touch only for referrer + landing path
    if (!existing.referrer) {
      merged.referrer = document.referrer || null;
    }
    if (!existing.landing_path) {
      merged.landing_path = url.pathname + url.search;
    }
    save(merged);
    return merged;
  } catch (err) {
    console.warn("attribution: capture failed, using saved snapshot", err);
    return readSaved() || {};
  }
}

export function getAttribution() {
  return readSaved() || {};
}
